import { useFrame, useThree } from "@react-three/fiber";
import { useMemo, useRef } from "react";
import * as THREE from "three";
import { easeOutCubic, getResponsiveCameraZ } from "../helpers";

export interface CameraFlyInProps {
  onComplete: () => void;
}

export function CameraFlyIn({ onComplete }: CameraFlyInProps) {
  const { camera, size } = useThree();
  const startTime = useRef<number | null>(null);
  const hasCompleted = useRef(false);

  const endZ = getResponsiveCameraZ(size.width, size.height);
  const duration = 3;
  const startPos = useMemo(() => new THREE.Vector3(0, 1, 18), []);
  const endPos = useMemo(() => new THREE.Vector3(0, 0, endZ), [endZ]);

  useFrame(({ clock }) => {
    if (hasCompleted.current) return;

    if (startTime.current === null) {
      startTime.current = clock.getElapsedTime();
      camera.position.copy(startPos);
    }

    const elapsed = clock.getElapsedTime() - startTime.current;
    const progress = Math.min(elapsed / duration, 1);
    const eased = easeOutCubic(progress);

    camera.position.lerpVectors(startPos, endPos, eased);
    camera.lookAt(0, 0, 0);

    if (progress >= 1 && !hasCompleted.current) {
      hasCompleted.current = true;
      onComplete();
    }
  });

  return null;
}
